// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--kfmw1","badge":"e2ff468f85--badge--I7LxC"};